
 const javaSetting = {
    'sit': 'https://baohuo-gateway-pre.mobvoi.com',
    'pre': 'https://baohuo-gateway-pre.mobvoi.com',
    'production': 'https://baohuo-gateway.mobvoi.com',
    'development': 'https://baohuo-gateway-pre.mobvoi.com',
  }
  const crawlerSetting={
    'sit': 'https://moyin-audio-video-crawler-sit.moyin.com',
    'pre': 'https://moyin-audio-video-crawler-sit.moyin.com',
    'production': 'https://moyin-audio-video-crawler.moyin.com',
    'development': 'https://moyin-audio-video-crawler-sit.moyin.com',
  }
const moyinSetting = {
  'sit': 'https://moyin-gateway-pre.mobvoi.com',
  'pre': 'https://moyin-gateway-pre.mobvoi.com',
  'production': 'https://moyin-gateway.mobvoi.com',
  'development': 'https://moyin-gateway-pre.mobvoi.com',
}

export let javaHost = javaSetting[process.env.VUE_APP_ENV || 'pre']
//@ts-ignore
window.setHost = function (yh) {
  if(yh){
    javaHost = yh
  }
}

  export let crawlerHost = crawlerSetting[process.env.VUE_APP_ENV || 'production']
export let moyinHost = moyinSetting[process.env.VUE_APP_ENV || 'production']